module.exports = __webpack_public_path__ + "img/15sback.98930ee6.svg";